import { CSSObject } from '@chakra-ui/react';

export const StartTime: CSSObject = {
  fontSize: '2xs',
  fontWeight: 'medium',
};
